var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilledPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: "auto",
    viewBox: "0 0 56 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44 34.65V9.9H48C50.2 9.9 52 7.6725 52 4.95C52 2.2275 50.2 0 48 0H8C5.8 0 4 2.2275 4 4.95C4 7.6725 5.8 9.9 8 9.9H12V34.65C12 41.3018 8.48753 46.9155 3.62697 48.8129C1.71698 49.5584 0 51.1621 0 53.2125V53.2125C0 56.6298 2.77024 59.4 6.1875 59.4H23.88V94.05L27.88 99L31.88 94.05V59.4H49.8125C53.2298 59.4 56 56.6298 56 53.2125V53.2125C56 51.1621 54.283 49.5584 52.373 48.8129C47.5125 46.9155 44 41.3018 44 34.65Z",
    fill: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledPin);
export default __webpack_public_path__ + "static/media/filledPin.66ae43cfbaa0a9fb24536c2c4e8179cd.svg";
export { ForwardRef as ReactComponent };